import { render, staticRenderFns } from "./BitSquare.vue?vue&type=template&id=1e522204&"
import script from "./BitSquare.vue?vue&type=script&lang=js&"
export * from "./BitSquare.vue?vue&type=script&lang=js&"
import style0 from "./BitSquare.vue?vue&type=style&index=0&id=1e522204&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports